import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CancelBatchEnrollmentBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const cancelEducationalAdvisorBatchEnrollment = createAsyncThunk<void, CancelBatchEnrollmentBody, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/cancelBatchEnrollment",
  async (command: CancelBatchEnrollmentBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.cancelEnrollment(command);
  },
);
